import React, { useEffect, useState } from "react";
import SunDeleteConfrm from "./SunDeleteConfirm";
import icon_filter from '../../_theme/_assets/images/icon_filter.svg';
import { useDispatch, useSelector } from "react-redux";
import { getAllSearchCriteria } from "../bookingConfirmation/thunks/getAllSearchCriteria";
import { deleteSearchCriteria } from "../bookingConfirmation/thunks/deleteSearchCriteria";
import moment from "moment";
import { createSearchCriteria } from "../bookingConfirmation/thunks/createSearchCriteria";
import { updateSearchCriteria } from "../bookingConfirmation/thunks/updateSearchCriteria";
import {
    AirlineMode,
    PreferredAirline,
    buildAirlinePayload,
    emptyPreferredRow,
    hydrateAirlineMode,
    hydratePreferredAirlines,
    hydrateProhibitedAirlines,
} from "./AirlineRestrictionFields";
import { SunquestCacheFormModal } from "./SunquestCacheFormModal";
import {
    AirlinesDisplay,
    PaxTypesDisplay,
    formatRepeatDisplay,
    formatRouteDisplay,
    formatTravelDatesDisplay,
} from "./SunquestCacheDisplay";

// Shared in-flight/list result so Strict Mode remounts don't spam getAllSearchCriterias
let sunquestListRequest: Promise<any> | null = null;

export const SunquestAdminList = () => {

    const dispatch = useDispatch();
    const [days, setDays] = useState({
        MONDAY: false,
        TUESDAY: false,
        WEDNESDAY: false,
        THURSDAY: false,
        FRIDAY: false,
        SATURDAY: false,
        SUNDAY: false,
    });
    const [daysShow, setDaysShow] = React.useState(false)
    const [addNew, setAddNew] = React.useState(false)
    const [fieldEdit, setfieldEdit] = React.useState(false)
    const [searchCiteria, setSearchCiteria] = useState<any[]>([])
    const [id, setId] = useState("")
    const [origin, setOrigin] = useState("")
    const [destination, setDestination] = useState("")
    const [departureStart, setDepartureStart] = useState("")
    const [departureEnd, setDepartureEnd] = useState("")
    const [maxStay, setMaxStay] = useState(1)
    const [repeats, setRepeats] = useState<any>([])
    const [tripType, setTripType] = useState<string>("")
    const [unavailablePaxTypes, setUnavailablePaxTypes] = useState<string[]>([])
    const [airlineMode, setAirlineMode] = useState<AirlineMode>("")
    const [preferredAirlines, setPreferredAirlines] = useState<PreferredAirline[]>([emptyPreferredRow()])
    const [prohibitedAirlines, setProhibitedAirlines] = useState<string[]>([])
    const [loading, setLoading] = useState(true)
    const [startDate, setStartDate] = useState(String(moment(new Date()).startOf("day").format("DD-MMM-YYYY")));
    const [endDate, setEndDate] = useState(String(moment(new Date()).startOf("day").format("DD-MMM-YYYY")));

    const correlationId = useSelector((state:any) => state.searchForm.uuid);

    const isFormOpen = addNew || Boolean(id);
    const formMode: "create" | "edit" = addNew ? "create" : "edit";

    const handleSetDays = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDays({ ...days, [event.target.name]: event.target.checked });
    };
    const handleDaysShow = (event: React.ChangeEvent<HTMLInputElement>) => {
        (event.target as HTMLInputElement).value === 'selectedDays' ? setDaysShow(true) : setDaysShow(false);
        setRepeats([])
        if((event.target as HTMLInputElement).value != "selectedDays" && (!repeats.includes("NEVER") || !repeats.includes("EVERYDAY"))){
            let temp:any = []
            temp.push((event.target as HTMLInputElement).value)
            setRepeats([...temp])
        }
        if((event.target as HTMLInputElement)?.value === 'NEVER' || (event.target as HTMLInputElement)?.value === 'EVERYDAY'){
            setDays(
                {
                    MONDAY: false,
                    TUESDAY: false,
                    WEDNESDAY: false,
                    THURSDAY: false,
                    FRIDAY: false,
                    SATURDAY: false,
                    SUNDAY: false,
                }
            )
        }
    };
    const handleAddNew = () => {
        setId("");
        setfieldEdit(false);
        setDaysShow(false);
        resetLocalState();
        setStartDate(String(moment(new Date()).startOf("day").format("DD-MMM-YYYY")));
        setEndDate(String(moment(new Date()).startOf("day").format("DD-MMM-YYYY")));
        setAddNew(true);
    }

    const handleAEdit = (search:any) => {
        setAddNew(false);
        setId(search?.id)
        setfieldEdit(true);
        setOrigin(search?.origin);
        setDestination(search?.destination);
        setMaxStay(search?.maxStay);
        setRepeats(Array.isArray(search?.repeats) ? search.repeats : [])
        setTripType(search?.tripType ?? "")
        setUnavailablePaxTypes(Array.isArray(search?.unavailablePaxTypes) ? search.unavailablePaxTypes : [])
        setAirlineMode(hydrateAirlineMode(search))
        setPreferredAirlines(hydratePreferredAirlines(search))
        setProhibitedAirlines(hydrateProhibitedAirlines(search))
        if(search?.repeats?.includes("MONDAY") || search?.repeats?.includes("TUESDAY") || search?.repeats?.includes("WEDNESDAY") || search?.repeats?.includes("THURSDAY") || search?.repeats?.includes("FRIDAY") || search?.repeats?.includes("SATURDAY") || search?.repeats?.includes("SUNDAY")){
            setDaysShow(true);
            setDays(
                {
                    MONDAY: search?.repeats?.includes("MONDAY"),
                    TUESDAY: search?.repeats?.includes("TUESDAY"),
                    WEDNESDAY: search?.repeats?.includes("WEDNESDAY"),
                    THURSDAY: search?.repeats?.includes("THURSDAY"),
                    FRIDAY: search?.repeats?.includes("FRIDAY"),
                    SATURDAY: search?.repeats?.includes("SATURDAY"),
                    SUNDAY: search?.repeats?.includes("SUNDAY"),
                }
            )
        } else {
            setDaysShow(false);
            setDays({
                MONDAY: false,
                TUESDAY: false,
                WEDNESDAY: false,
                THURSDAY: false,
                FRIDAY: false,
                SATURDAY: false,
                SUNDAY: false,
            });
        }
        setDepartureStart(search?.deptStarts)
        setDepartureEnd(search?.deptEnds)
    }

    const closeFormModal = () => {
        setAddNew(false);
        setId("");
        setfieldEdit(false);
        setDaysShow(false);
        resetLocalState();
    }

    const normalizeSearchCriteriaList = (data: any): any[] => {
        if (!Array.isArray(data)) return [];
        return data.map((item: any) => ({
            ...item,
            repeats: Array.isArray(item?.repeats) ? item.repeats : [],
            unavailablePaxTypes: Array.isArray(item?.unavailablePaxTypes) ? item.unavailablePaxTypes : [],
            preferredAirlines: Array.isArray(item?.preferredAirlines) ? item.preferredAirlines : [],
            prohibitedAirlines: Array.isArray(item?.prohibitedAirlines) ? item.prohibitedAirlines : [],
        }));
    };

    const getSearcgCiteriaList = async()=>{
        const request = Promise.resolve(dispatch(getAllSearchCriteria())).catch((err) => {
            if (sunquestListRequest === request) {
                sunquestListRequest = null;
            }
            throw err;
        });
        sunquestListRequest = request;
        try {
            const allSearchCriteria: any = await request;
            setSearchCiteria(normalizeSearchCriteriaList(allSearchCriteria));
        } finally {
            setLoading(false);
        }
    }
    useEffect(()=>{
        let cancelled = false;
        let request = sunquestListRequest;

        if (!request) {
            request = Promise.resolve(dispatch(getAllSearchCriteria())).catch((err) => {
                if (sunquestListRequest === request) {
                    sunquestListRequest = null;
                }
                throw err;
            });
            sunquestListRequest = request;
        }

        const loadSearchCriteria = async () => {
            try {
                const allSearchCriteria: any = await request;
                if (cancelled) return;
                setSearchCiteria(normalizeSearchCriteriaList(allSearchCriteria));
            } catch (err) {
                console.log("getAllSearchCriteria failed", err);
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };

        loadSearchCriteria();
        setfieldEdit(false);
        resetLocalState();

        return () => {
            cancelled = true;
            // Clear after a beat so Strict Mode remount can reuse the same in-flight request
            window.setTimeout(() => {
                if (sunquestListRequest === request) {
                    sunquestListRequest = null;
                }
            }, 250);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const deleteRecord = async(id:any) => {
        let deleteOp:any = await deleteSearchCriteria(id, correlationId)
        if(deleteOp){
            getSearcgCiteriaList()
        }else{
            // toast error that deletion operation failed
        }
    }

    const setOriginHandle = (val:any) => {
        setOrigin(val)
    }
    const setDestinationHandle = (val:any) =>{
        setDestination(val)
    }

    const setDepartureStartDateHandle = (date:any) => {
        if (!date || isNaN(new Date(date).getTime())) return;
        const next = String(moment(new Date(date)).startOf("day").format("DD-MMM-YYYY"));
        setDepartureStart((prev) => (prev === next ? prev : next));
    }

    const setDepartureEndDateHandle = (date:any) => {
        if (!date || isNaN(new Date(date).getTime())) return;
        const next = String(moment(new Date(date)).startOf("day").format("DD-MMM-YYYY"));
        setDepartureEnd((prev) => (prev === next ? prev : next));
    }

    const setCreateStartDateHandle = (date:any) => {
        if (!date || isNaN(new Date(date).getTime())) return;
        const next = String(moment(new Date(date)).startOf("day").format("DD-MMM-YYYY"));
        setStartDate((prev) => (prev === next ? prev : next));
    }

    const setCreateEndDateHandle = (date:any) => {
        if (!date || isNaN(new Date(date).getTime())) return;
        const next = String(moment(new Date(date)).startOf("day").format("DD-MMM-YYYY"));
        setEndDate((prev) => (prev === next ? prev : next));
    }

    const setMaxStayHandle = (val:any) => {
        setMaxStay(Number(val))
    }

    const setRepeatsHandle = (event: React.ChangeEvent<HTMLInputElement>) => {
        let temp:any = [...repeats]
        if(temp.includes((event.target as HTMLInputElement).name)){
            temp.splice(temp.indexOf((event.target as HTMLInputElement).name), 1)
        }else{
            temp.push((event.target as HTMLInputElement).name)
        }
        setRepeats([...temp])
    }

    const handleUnavailablePaxTypes = (event: React.ChangeEvent<HTMLInputElement>) => {
        const name = (event.target as HTMLInputElement).name;
        setUnavailablePaxTypes(prev => {
            const current = Array.isArray(prev) ? prev : [];
            return current.includes(name) ? current.filter(v => v !== name) : [...current, name];
        });
    }

    const createSearchCiteria = async () => {
        if(!tripType){
            alert("Please select Trip Type (TOW / RT / BOTH).");
            return;
        }
        const airlinePayload = buildAirlinePayload(airlineMode, preferredAirlines, prohibitedAirlines)
        const payload =
        {
            "origin": origin,
            "destination": destination,
            "maxStay": maxStay,
            "repeats": repeats,
            "tripType": tripType,
            "unavailablePaxTypes": unavailablePaxTypes,
            "preferredAirlines": airlinePayload.preferredAirlines,
            "prohibitedAirlines": airlinePayload.prohibitedAirlines,
            "deptStarts": startDate,
            "deptEnds": endDate
        }
        const createOperation:any =  await createSearchCriteria(payload, correlationId)
        if(createOperation?.data?.id && createOperation?.data?.message == "Success"){
            getSearcgCiteriaList()
            resetLocalState()
        }
        else{
            // toast error msg
        }
        setAddNew(false);
        setDaysShow(false);
    }

    const updateSearchCri = (search:any) => {
        if(!tripType){
            alert("Please select Trip Type (TOW / RT / BOTH).");
            return;
        }
        setLoading(true)
        const airlinePayload = buildAirlinePayload(airlineMode, preferredAirlines, prohibitedAirlines)
        const payload =
        {
            "origin": origin,
            "destination": destination,
            "maxStay": maxStay,
            "repeats": repeats,
            "tripType": tripType,
            "unavailablePaxTypes": unavailablePaxTypes,
            "preferredAirlines": airlinePayload.preferredAirlines,
            "prohibitedAirlines": airlinePayload.prohibitedAirlines,
            "deptStarts": departureStart,
            "deptEnds": departureEnd
        }
        
        let updateOperation:any = updateSearchCriteria(payload, search?.id, correlationId)
        if(updateOperation){
            setTimeout(() => {
                getSearcgCiteriaList()
              }, 1000);
            
            resetLocalState();
            setId("")
            setDaysShow(false);
            setfieldEdit(false);
        }
    }

    const handleFormSave = () => {
        if (addNew) {
            createSearchCiteria();
            return;
        }
        const search = (Array.isArray(searchCiteria) ? searchCiteria : []).find(
            (item: any) => item?.id == id
        );
        updateSearchCri(search || { id });
    }

    const resetLocalState = () => {
        setOrigin("");
        setDestination("");
        setMaxStay(1);
        setRepeats([""])
        setTripType("")
        setUnavailablePaxTypes([])
        setAirlineMode("")
        setPreferredAirlines([emptyPreferredRow()])
        setProhibitedAirlines([])
        setDepartureStart("")
        setDepartureEnd("")
        setDays(
            {
                MONDAY: false,
                TUESDAY: false,
                WEDNESDAY: false,
                THURSDAY: false,
                FRIDAY: false,
                SATURDAY: false,
                SUNDAY: false,
            }
        )
    }

    return (
        <>
            <div className="sunquestAdminList bgNone">
                <div className="card cm-card bgNone">
                    <div className="card-header cm-card-head-btn  bgNone">
                        <div>
                            <button className="cm-secondary-btn mr-3 btn-sort"> <i className="fas fa-exchange-alt"></i>Sort by</button>
                            <button className="cm-secondary-btn filterBtn"> <img src={icon_filter}/>Filter</button>
                        </div>
                        <button className="cm-yellow-btn" onClick={handleAddNew}>Add New</button>
                    </div>
                    <hr className="m-0" />
                    <div className="table-responsive-sm sunquestCompactTableWrap">
                        <table role="table" className="table sunquestCompactTable">
                            <thead>
                                <tr>
                                    <th><i className="fas fa-route" aria-hidden="true"></i>Route</th>
                                    <th><i className="far fa-calendar-alt" aria-hidden="true"></i>Travel Dates</th>
                                    <th><i className="fas fa-home" aria-hidden="true"></i>Max Stay</th>
                                    <th><i className="fas fa-retweet" aria-hidden="true"></i>Repeat</th>
                                    <th><i className="fas fa-exchange-alt" aria-hidden="true"></i>Trip Type</th>
                                    <th><i className="fas fa-user-slash" aria-hidden="true"></i>Unavailable Pax Types</th>
                                    <th><i className="fas fa-plane" aria-hidden="true"></i>Airlines</th>
                                    <th className="edit-border"><i className="fas fa-cog" aria-hidden="true"></i>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={8} className="sunquestLoadingCell">LOADING...</td>
                                    </tr>
                                ) : (
                                    (Array.isArray(searchCiteria) ? searchCiteria : []).map((search: any) => (
                                        <tr className="bgWhite sunquestCompactRow" key={search?.id}>
                                            <td className="sunquestRouteCell">
                                                {formatRouteDisplay(search?.origin, search?.destination)}
                                            </td>
                                            <td className="sunquestDatesCell">
                                                {formatTravelDatesDisplay(search?.deptStarts, search?.deptEnds)}
                                            </td>
                                            <td>{search?.maxStay ?? "-"}</td>
                                            <td>{formatRepeatDisplay(search?.repeats)}</td>
                                            <td>{search?.tripType || "-"}</td>
                                            <td>
                                                <PaxTypesDisplay types={search?.unavailablePaxTypes} />
                                            </td>
                                            <td>
                                                <AirlinesDisplay search={search} />
                                            </td>
                                            <td className="edit-border">
                                                <div className="cm-edidel-btns">
                                                    <button
                                                        className="cm-edit-btn mr-2"
                                                        onClick={() => handleAEdit(search)}
                                                        id={search?.id}
                                                    >
                                                        <i className="fas fa-edit"></i>
                                                    </button>
                                                    <SunDeleteConfrm deleteRecord={deleteRecord} id={search?.id} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                </div>

                <SunquestCacheFormModal
                    open={isFormOpen}
                    mode={formMode}
                    title={formMode === "create" ? "Add New" : "Edit Cache Criteria"}
                    onClose={closeFormModal}
                    origin={origin}
                    destination={destination}
                    onOriginChange={setOriginHandle}
                    onDestinationChange={setDestinationHandle}
                    departureStart={formMode === "create" ? startDate : departureStart}
                    departureEnd={formMode === "create" ? endDate : departureEnd}
                    onDepartureStartChange={
                        formMode === "create" ? setCreateStartDateHandle : setDepartureStartDateHandle
                    }
                    onDepartureEndChange={
                        formMode === "create" ? setCreateEndDateHandle : setDepartureEndDateHandle
                    }
                    maxStay={maxStay}
                    onMaxStayChange={setMaxStayHandle}
                    days={days}
                    daysShow={daysShow}
                    onDaysShowChange={handleDaysShow}
                    onDayToggle={handleSetDays}
                    onRepeatsHandle={setRepeatsHandle}
                    repeats={repeats}
                    tripType={tripType}
                    onTripTypeChange={setTripType}
                    unavailablePaxTypes={unavailablePaxTypes}
                    onUnavailablePaxTypesChange={handleUnavailablePaxTypes}
                    airlineMode={airlineMode}
                    preferredAirlines={preferredAirlines}
                    prohibitedAirlines={prohibitedAirlines}
                    onAirlineModeChange={setAirlineMode}
                    onPreferredChange={setPreferredAirlines}
                    onProhibitedChange={setProhibitedAirlines}
                    onSave={handleFormSave}
                    onCancel={closeFormModal}
                />
            </div>

        </>
    )
}
